<template>
  <nav class="navbar-expand navbar-light bg-light">
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item"><router-link class="nav-link" to="/services">MOJE SLUŽBY</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/devices">MOJE KONCOVÁ ZAŘÍZENÍ</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/account">MŮJ ÚČET<span v-if="nedoplatek" id="nedoplatek" class="badge badge-pill badge-danger">-{{nedoplatek}} Kč</span></router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/findocs">MOJE FAKTURY</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/personal">OSOBNÍ ÚDAJE</router-link></li>
        <li class="nav-item"><router-link class="nav-link" to="/referral">DOPORUČ &amp; ZÍSKEJ</router-link></li>
      </ul>
    </div>
  </nav>
</template>
<script>
export default {
  name: 'rd-samoobsluha-navbar',
  computed: {
    nedoplatek () {
      if (this.$store.state.cashTotals.overdue_amount > 0) {
        return parseFloat(this.$store.state.cashTotals.overdue_amount).toFixed(2)
      }
      return false
    }
  }
}
</script>
<style scoped>
nav {
  font-size: 1rem;
}
li+li {
  margin-left: 0.5em;
}
.router-link-exact-active {
  color: #007bff !important;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  padding-bottom: 11px;
  border-bottom-width: 5px;
  border-color: #007bff;
  border-style: solid;
}
span#nedoplatek {
  margin-left: 0.5em;
  padding: 0.5em;
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?47e7db22